import PolicyIcon from "@mui/icons-material/Policy";
export const words = [
  {
    id: 0,
    word: ["Accompagnement", "Audit"], // - Audit
    letter: "A",
  },
  {
    id: 1,
    word: "Formation",
    letter: "F",
  },
  {
    id: 2,
    word: "Règlementation",
    letter: "R",
  },
  {
    id: 3,
    word: "Ingénierie",
    letter: "I",
  },
  {
    id: 4,
    word: "Q",
    letter: "Q",
  },
  {
    id: 4,
    word: "U",
    letter: "U",
  },
  {
    id: 4,
    word: "A",
    letter: "A",
  },
  {
    id: 4,
    word: "LITÉ",
    letter: "L",
  },
  {
    id: 5,
    word: "Environnement",
    letter: "E",
  },
  {
    id: 6,
    word: "Organisation",
    letter: "O",
  },
  {
    id: 7,
    word: "Sécurité",
    letter: "S",
  },
];
